import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IntlService } from '@progress/kendo-angular-intl';
import { PageBaseComponent } from './page-base.component';
import { AuthService, DatasourceService } from '@app/core/services';
import { NotificationService } from "@progress/kendo-angular-notification";
import { DialogService, DialogRef, DialogCloseResult } from "@progress/kendo-angular-dialog";
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';
import { Location } from '@angular/common';


@Component({
  selector: 'expense-actions',  
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-form.css'],
  styles: [`
    form {
      padding: 0 15px 132px 15px;
    }
  `],  
  template: `

    <div class="wrapper-route-0">

      <div class="k-block" *ngIf="loading">
        <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
      </div>

      <form novalidate [formGroup]="form">
        <div class="example-wrapper form-detail">        
          <div class="row">
            <div class="col-field">
              <kendo-label text="Gasto - {{ mode == 'CREATE' ? 'Nuevo': 'Editar' }}"></kendo-label>              
            </div>
            <div class="col-field">
              <kendo-label text="Fecha:"></kendo-label>
              <kendo-textbox-container>
                <kendo-datepicker formControlName="date" [format]="'dd-MMM-yyyy'"></kendo-datepicker>
              </kendo-textbox-container> 
              <div *ngIf="f.date.invalid && (f.date.dirty || f.date.touched)">                  
                <div *ngIf="f.date.errors">
                  <kendo-formerror *ngIf="f.date.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>  
            <div class="col-field">
              <kendo-label text="Proveedor:"></kendo-label>
              <kendo-textbox-container>
                <dynamic-autocomplete formControlName="supplier" [table]="'expenses_inventories'" [valueField]="'supplier'" [showAll]="true" controlTrim></dynamic-autocomplete>
              </kendo-textbox-container> 
              <div *ngIf="f.supplier.invalid && (f.supplier.dirty || f.supplier.touched)">                  
                <div *ngIf="f.supplier.errors">
                  <kendo-formerror *ngIf="f.supplier.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>
            <div class="col-field">
              <kendo-label text="Tipo de gasto:"></kendo-label>
              <kendo-textbox-container>
                <dynamic-dropdownlist formControlName="id_expense_type" [table]="'expenses_types'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </kendo-textbox-container> 
              <div *ngIf="f.id_expense_type.invalid && (f.id_expense_type.dirty || f.id_expense_type.touched)">                  
                <div *ngIf="f.id_expense_type.errors">
                  <kendo-formerror *ngIf="f.id_expense_type.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>
            <div class="col-field">
              <kendo-label text="Forma de pago:"></kendo-label>
              <kendo-textbox-container>
                <dynamic-dropdownlist formControlName="id_payment_type" [table]="'payments_types'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </kendo-textbox-container> 
              <div *ngIf="f.id_payment_type.invalid && (f.id_payment_type.dirty || f.id_payment_type.touched)">                  
                <div *ngIf="f.id_payment_type.errors">
                  <kendo-formerror *ngIf="f.id_payment_type.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>   
            <div class="col-field">
              <kendo-label text="Importe:"></kendo-label>
              <kendo-textbox-container>
                <kendo-numerictextbox formControlName="cost" [format]="'c2'" [min]="0" [autoCorrect]="true"></kendo-numerictextbox>
              </kendo-textbox-container> 
              <div *ngIf="f.cost.invalid && (f.cost.dirty || f.cost.touched)">                  
                <div *ngIf="f.cost.errors">
                  <kendo-formerror *ngIf="f.cost.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>   
            <div class="col-field">
              <kendo-label text="Forma de pago:"></kendo-label>
              <kendo-textbox-container>
                <dynamic-dropdownlist formControlName="id_person_authorize" [table]="'persons'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </kendo-textbox-container> 
              <div *ngIf="f.id_person_authorize.invalid && (f.id_person_authorize.dirty || f.id_person_authorize.touched)">                  
                <div *ngIf="f.id_person_authorize.errors">
                  <kendo-formerror *ngIf="f.id_person_authorize.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div> 
            <div class="col-field">
              <kendo-label text="Descripción:"></kendo-label>
              <kendo-textbox-container>
                <kendo-textbox formControlName="description"></kendo-textbox>
              </kendo-textbox-container> 
              <div *ngIf="f.description.invalid && (f.description.dirty || f.description.touched)">                  
                <div *ngIf="f.description.errors">
                  <kendo-formerror *ngIf="f.description.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div> 
            <div class="col-field">
              <kendo-label text="Observaciones:"></kendo-label>
              <kendo-textbox-container>
                <kendo-textarea formControlName="observations" [rows]="3"></kendo-textarea>
              </kendo-textbox-container> 
              <div *ngIf="f.observations.invalid && (f.observations.dirty || f.observations.touched)">                  
                <div *ngIf="f.observations.errors">
                  <kendo-formerror *ngIf="f.observations.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>        
          </div>
        </div>
      </form>

      <kendo-floatingactionbutton icon="arrow-left" themeColor="secondary" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'start', vertical: 'bottom' }" positionMode="fixed" (click)="goBack()"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="save" themeColor="info" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="onSave($event)" [disabled]='!form.valid && !loading' *ngIf="authService.hasPermission(['GASTOS:EDITAR'])"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="trash" themeColor="error" [offset]="{ x: '78px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="delete()" *ngIf="mode == 'EDIT' && authService.hasPermission(['GASTOS:ELIMINAR'])">
        
      </kendo-floatingactionbutton>

    </div>

    <div kendoDialogContainer></div>

  `    
})
export class ExpenseActionsComponent extends PageBaseComponent implements OnInit {
  
  public id: number = 0;

  public mode = 'CREATE';

  public table: string = 'expenses_inventories';

  public form!: FormGroup;

  public loading = false;

  public dataItem: any = {};

  public returnUrl: string = 'expenses';

  private sub: any;


  constructor(public authService: AuthService, protected router: Router, protected route: ActivatedRoute, protected service : DatasourceService, protected intl: IntlService, private notificationService: NotificationService, private dialogService: DialogService, private location: Location) { 

    super(authService, router)

    let state = location.getState() as {returnUrl: string};
    if(state.returnUrl != null)
      this.returnUrl = state.returnUrl;
    // console.log(this.returnUrl);
    
  }

  //@Override
  protected getFormGroup(dataItem?: any): FormGroup {

    const tzDate = ZonedDate.fromUTCDate((dataItem) ? new Date(dataItem.date) : new Date(), environment.timezone);

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),  
      'date': new FormControl((dataItem) ?new Date(tzDate.toUTCString().replace('Dev', 'Dec')): new Date(), Validators.required),
      'supplier': new FormControl((dataItem) ? dataItem.supplier: '', Validators.required),
      'id_person_authorize': new FormControl((dataItem) ? dataItem.id_person_authorize: 0, Validators.required),
      'id_expense_type': new FormControl((dataItem) ? dataItem.id_expense_type: 1, Validators.required),
      'id_payment_type': new FormControl((dataItem) ? dataItem.id_payment_type: 1, Validators.required),
      'cost': new FormControl((dataItem) ? dataItem.cost: 0, Validators.required),
      'description': new FormControl((dataItem) ? dataItem.description: '', Validators.required),
      'observations': new FormControl((dataItem) ? dataItem.observations: ''),
    });

  };

  ngOnInit() {

    // this.form = this.getFormGroup();
    // this.update();

    this.sub = this.route.data.subscribe(v => {
      // console.log(v);
      this.mode = v.mode;
      this.form = this.getFormGroup();
      if(this.mode == 'CREATE') {

      }
      else {
        let id = this.route.snapshot.paramMap.get('id');
        this.id = (id != null) ? parseInt(id): 0;

        // console.log(this.router.getCurrentNavigation());
        this.loading = true;

        this.service.getById(this.table, this.id)
          .subscribe(
            (result: any) => {
              // console.log(result);
              this.dataItem = result;

              this.loading = false;

              this.form = this.getFormGroup(result);
            },
            (error: any) => {
              console.log(error)
              // this.loading = false;
            });

      }

    });

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  protected getData(formGroup: FormGroup): Object {

    return Object.assign({}, formGroup.value, { 
      date: this.intl.formatDate(formGroup.value.date, "yyyy-MM-dd"),
    });

  };

  public onDelete(): void {

    this.loading = true;

    this.service.removeRow(this.table, this.dataItem)
      .subscribe(
        (res: any) => {
          console.log('Eliminadosssss', res);

          this.loading = false;

          const dialog: DialogRef = this.dialogService.open({
            title: "Éxito",
            content: `Se eliminó con éxito ${this.getMessage()}`,
            actions: [{ text: "Ok", primary: true }],
            width: '80%',
            // height: 200,
            // minWidth: 250,
          });
        
          dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                // console.log("close");
            }
            this.goBack()
          });

        },
        (error: any) => {
          console.log(error)
          // this.loading = false;
        });

  }

  public onSave(event: any): void {
  
    if(this.form.valid) {

      let data = this.getData(this.form);
      // console.log('data', data)

      this.loading = true;

      if(this.mode == 'CREATE'){
          // console.log(data);
        this.service.addRow(this.table, data) 
          .subscribe(
            (res: any) => {
              console.log("POST Request is successful: ", this.table, data, res);

              this.dataItem = res.data[0];

              this.loading = false;

              const dialog: DialogRef = this.dialogService.open({
                title: "Éxito",
                content: `Se registró con éxito ${this.getMessage()}`,
                actions: [{ text: "Ok", primary: true }],
                width: '80%',
                // height: 200,
                // minWidth: 250,
              });
            
              dialog.result.subscribe((result) => {
                if (result instanceof DialogCloseResult) {
                    // console.log("close");
                }
                this.goBack()
              });

            },
            (fail: any) => {        
              console.log("Error", fail);
              // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
            }
          ); 
      }
      else {
        this.service.updateRow(this.table, data) 
          .subscribe(
            (res: any) => {
              console.log("PUT Request is successful: ", this.table, data);
              // console.log("mode = " + this.mode);
              this.dataItem = data;
              // this.save.emit({mode: this.mode, dataItem: res.data[0]});

              // this.notificationService.show({
              //     content: `Se registró con éxito el costo de grúa de ${this.intl.formatNumber(res.data[0].cost_crane, "c2")}`,
              //     hideAfter: 1000,
              //     position: { horizontal: "center", vertical: "top" },
              //     animation: { type: "fade", duration: 400 },
              //     type: { style: "success", icon: true },
              //   });

              // this.update();

              this.loading = false;

              const dialog: DialogRef = this.dialogService.open({
                title: "Éxito",
                content: `Se editó con éxito ${this.getMessage()}`,
                actions: [{ text: "Ok", primary: true }],
                width: '80%',
                // height: 200,
                // minWidth: 250,
              });
            
              dialog.result.subscribe((result) => {
                if (result instanceof DialogCloseResult) {
                    // console.log("close");
                }
                this.goBack()
              });

            },
            (fail: any) => {        
              console.log("Error", fail);
              // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
            }
          ); 
      }

    }
    
  }

  public delete() {

    // let that = this;
  
    const dialog: DialogRef = this.dialogService.open({
      title: "Confirmar",
      content: `¿Esta seguro que desea eliminar ${this.getMessage()}?`,
      actions: [{ text: "No", primary: true }, { text: "Sí" }],
      width: '80%',
      // height: 200,
      // minWidth: 250,
    });
  
    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
          // console.log("close");
      }
      else {
        // console.log(result);
        if(result.text == 'Sí') {
          // this.save();
          this.onDelete();
        }
      }
    });

  }

  public goBack() {

    this.router.navigate([`/${this.returnUrl}`]);

  }

  public getMessage() {

    return `el gasto de ${this.intl.formatNumber(this.dataItem.cost, "c2")}, ${this.dataItem.supplier}, ${this.dataItem.description}. ID: [${this.dataItem.id}]?`;

  }
      
}